import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { useLanguage } from "@/context/LanguageContext";

export const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();

  const languages = [
    { code: "en", flag: "US", label: "English" },
    { code: "es", flag: "ES", label: "Espanol" },
    { code: "pt", flag: "BR", label: "Portugues" },
    { code: "fr", flag: "FR", label: "Francais" },
  ];

  return (
    <div className="relative">
      <Select value={language} onValueChange={setLanguage}>
        <SelectTrigger
          data-testid="language-selector"
          className="w-[100px] border-[#003A4B]/30 bg-white/80 backdrop-blur-sm"
        >
          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4 text-[#003A4B]" />
            <span className="text-sm font-medium">{language.toUpperCase()}</span>
          </div>
        </SelectTrigger>
        <SelectContent>
          {languages.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <div className="flex items-center gap-2">
                <span>{lang.flag}</span> {lang.label}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
